export class Plugin {
    constructor(sdk) {
        this.sdk = sdk;
    }
}
//# sourceMappingURL=index.js.map